import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import themeable from 'zignal-landscape/lib/themeable';
import DownloadIcon from 'zignal-landscape/lib/Icon/DownloadIcon';
import MfeIconWrapper from '../../containers/DiscoverHistorics/components/MfeIconWrapper/MfeIconWrapper';
import OutsideAlerter from '../../components/OutsideAlerter/OutsideAlerter';
import Menu from './Menu';

const DownloadMenu = ({
  styles,
  getAuthorsAndStories,
  fileNameWithoutExtension,
  exportFileName,
  mfeMode = false
}) => {
  const [open, setOpen] = useState(false);

  const menu = (<Menu
    fileNameWithoutExtension={fileNameWithoutExtension}
    getAuthorsAndStories={getAuthorsAndStories}
    exportFileName={exportFileName}
  />);
  const tooltipProps = {
    position: 'bottom',
    tooltipText: menu,
    width: 95,
    trigger: 'click'
  };

  return mfeMode ? (
    <OutsideAlerter onClick={() => setOpen(false)}>
      <ToolTip {...tooltipProps}>
        <MfeIconWrapper onClick={() => setOpen(!open)} icon={DownloadIcon} open={open} tooltipProps={{ tooltipText: 'Export Data' }} />
      </ToolTip>
    </OutsideAlerter>
  ) : (
    <ToolTip {...tooltipProps}>
      <a className={styles.button}>
        <DownloadIcon /> Export Data
      </a>
    </ToolTip>
  );
};

DownloadMenu.propTypes = {
  styles: PropTypes.object.isRequired,
  getAuthorsAndStories: PropTypes.func.isRequired,
  fileNameWithoutExtension: PropTypes.string.isRequired,
  exportFileName: PropTypes.string.isRequired,
  mfeMode: PropTypes.bool
};

export default themeable(DownloadMenu);
